/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { Card } from "@curefit/pandora";
import { useIsMobile, useIsTab } from "../../hooks/useIsMobile";
import { RegistrationLayoutProps } from "./interfaces";
import { registrationLayoutStyle } from "./styles";

export const RegistrationLayout: React.FunctionComponent<RegistrationLayoutProps> = (
  props
) => {
  const isMobileView = useIsMobile();
  const isTabView = useIsTab();
  return (
    <span css={registrationLayoutStyle}>
      <div
        className={`${
          isMobileView || isTabView ? "container-fluid" : "container"
        }`}
      >
        <div className="row">
          <div
            className={`col-12 p-0  ${isMobileView || isTabView ? "p-0" : ""}`}
          >
            <Card
              className={`d-flex justify-content-center flex-column ${
                isMobileView || isTabView
                  ? "status-background p-4"
                  : "mt-4 padding-container p-5"
              }`}
            >
              {props.children}
            </Card>
          </div>
        </div>
      </div>
    </span>
  );
};
